import Dinero from "dinero.js";
import ApiMoney from "../api/Common/ApiMoney";

export const dinero = (money: ApiMoney) => {
    return Dinero({currency: money.currency as Dinero.Currency, amount: money.cents})
}